// Adapted from https://github.com/ndaidong/txtgen/blob/main/src/sample.js

export let nouns: string[] = ['alligator', 'ant', 'bear', 'bee', 'bird', 'camel', 'cat', 'cheetah', 'chicken', 'chimpanzee', 'cow', 'crocodile', 'deer', 'dog', 'dolphin', 'duck', 'eagle', 'elephant', 'fish', 'fly', 'fox', 'frog', 'giraffe', 'goat', 'goldfish', 'hamster', 'hippopotamus', 'horse', 'kangaroo', 'kitten', 'lion', 'lobster', 'monkey', 'octopus', 'owl', 'panda', 'pig', 'puppy', 'rabbit', 'rat', 'scorpion', 'seal', 'shark', 'sheep', 'snail', 'snake', 'spider', 'squirrel', 'tiger', 'turtle', 'wolf', 'zebra', 'apple', 'apricot', 'banana', 'blackberry', 'blueberry', 'cherry', 'cranberry', 'currant', 'fig', 'grape', 'grapefruit', 'grapes', 'kiwi', 'kumquat', 'lemon', 'lime', 'melon', 'nectarine', 'orange', 'peach', 'pear', 'persimmon', 'pineapple', 'plum', 'pomegranate', 'prune', 'raspberry', 'strawberry', 'tangerine', 'watermelon']
export let adjectives: string[] = ['adaptable', 'adventurous', 'affable', 'affectionate', 'agreeable', 'alert', 'alluring', 'ambitious', 'ambitious', 'amiable', 'amicable', 'amused', 'amusing', 'boundless', 'brave', 'brave', 'bright', 'bright', 'broad-minded', 'calm', 'calm', 'capable', 'careful', 'charming', 'charming', 'cheerful', 'coherent', 'comfortable', 'communicative', 'compassionate', 'confident', 'conscientious', 'considerate', 'convivial', 'cooperative', 'courageous', 'courageous', 'courteous', 'creative', 'credible', 'cultured', 'dashing', 'dazzling', 'debonair', 'decisive', 'decisive', 'decorous', 'delightful', 'detailed', 'determined', 'determined', 'diligent', 'diligent', 'diplomatic', 'discreet', 'discreet', 'dynamic', 'dynamic', 'eager', 'easygoing', 'efficient', 'elated', 'eminent', 'emotional', 'enchanting', 'encouraging', 'endurable', 'energetic', 'energetic', 'entertaining', 'enthusiastic', 'enthusiastic', 'excellent', 'excited', 'exclusive', 'exuberant', 'exuberant', 'fabulous', 'fair', 'fair-minded', 'faithful', 'faithful', 'fantastic', 'fearless', 'fearless', 'fine', 'forceful', 'frank', 'frank', 'friendly', 'friendly', 'funny', 'funny', 'generous', 'generous', 'gentle', 'gentle', 'glorious', 'good', 'good', 'gregarious', 'happy', 'hard-working', 'harmonious', 'helpful', 'helpful', 'hilarious', 'honest', 'honorable', 'humorous', 'imaginative', 'impartial', 'impartial', 'independent', 'industrious', 'instinctive', 'intellectual', 'intelligent', 'intuitive', 'inventive', 'jolly', 'joyous', 'kind', 'kind', 'kind-hearted', 'knowledgeable', 'level', 'likeable', 'lively', 'lovely', 'loving', 'loving', 'loyal', 'lucky', 'mature', 'modern', 'modest', 'neat', 'nice', 'nice', 'obedient', 'optimistic', 'painstaking', 'passionate', 'patient', 'peaceful', 'perfect', 'persistent', 'philosophical', 'pioneering', 'placid', 'placid', 'plausible', 'pleasant', 'plucky', 'plucky', 'polite', 'powerful', 'practical', 'pro-active', 'productive', 'protective', 'proud', 'punctual', 'quick-witted', 'quiet', 'quiet', 'rational', 'receptive', 'reflective', 'reliable', 'relieved', 'reserved', 'resolute', 'resourceful', 'responsible', 'rhetorical', 'righteous', 'romantic', 'romantic', 'sedate', 'seemly', 'selective', 'self-assured', 'self-confident', 'self-disciplined', 'sensible', 'sensitive', 'sensitive', 'shrewd', 'shy', 'silly', 'sincere', 'sincere', 'skillful', 'smiling', 'sociable', 'splendid', 'steadfast', 'stimulating', 'straightforward', 'successful', 'succinct', 'sympathetic', 'talented', 'thoughtful', 'thoughtful', 'thrifty', 'tidy', 'tough', 'tough', 'trustworthy', 'unassuming', 'unbiased', 'understanding', 'unusual', 'upbeat', 'versatile', 'vigorous', 'vivacious', 'warm', 'warmhearted', 'willing', 'willing', 'wise', 'witty', 'witty', 'wonderful']


export let sentenceTemplates: string[] = [
  '{{noun}} of the imagination how far away muse about bits of moving {{adjective}} {{noun}} preserve and cherish that pale, {{adjective}}, {{adjective}} {{noun}} the sky calls to us',
  'venture {{noun}} dream of the mind\'s eye the {{noun}} calls to us another world {{adjective}} permanence of the {{noun}}.',
  'a billion trillion encyclopaedia galactica {{adjective}} {{noun}} across the centuries the carbon in {{adjective}} {{noun}}?',
  "by accepting the {{noun}} or its derivative {{nouns}}. Therefore, for any liability to {{noun}} for claims brought by any {{noun}} to the page history is sufficient. Licensing notice: Each copy or copies of {{noun}}, provided that you cannot distribute so as to which you describe recipients' rights hereunder. However, you may modify your copy of this component of the {{noun}}, or portion thereof, is at Your sole responsibility, not on behalf of the printed materials and {{nouns}} within such {{nouns}} within which they are first used, and the following in a manner equivalent to the {{noun}}, it is up to the terms of this definition, '{{noun}}' means any patent claims against the {{nouns}} form or documentation, if provided along with the {{nouns}} must agree that use of the name of the licenses to their respective portions thereof.",
  '{{aNoun}} has the right to modify the terms of any of the {{nouns}}. Any material to the {{nouns}} or {{nouns}} thereof',
  'however, {{nouns}} have begun to rent {{nouns}} over the past few months, specifically for {{nouns}} associated with their {{nouns}}',
]

export const phrases = [
  'to be more specific, ',
  'in recent years, ',
  'however, ',
  'by the way',
  'of course, ',
  'some assert that ',
  'if this was somewhat unclear, ',
  'unfortunately, that is wrong; on the contrary, ',
  'it\'s very tricky, if not impossible, ',
  'this could be, or perhaps ',
  'this is not to discredit the idea that ',
  'we know that ',
  'it\'s an undeniable fact, really; ',
  'framed in a different way, ',
  'what we don\'t know for sure is whether or not ',
  'as far as we can estimate, ',
  'as far as he is concerned, ',
  'the zeitgeist contends that ',
  'though we assume the latter, ',
  'far from the truth, ',
  'extending this logic, ',
  'nowhere is it disputed that ',
  'in modern times ',
  'in ancient times ',
  'recent controversy aside, ',
  'washing and polishing the car,',
  'having been a gymnast, ',
  'after a long day at school and work, ',
  'waking to the buzz of the alarm clock, ',
  'draped neatly on a hanger, ',
  'shouting with happiness, ',
]

const mergeArray = (aArr: string[] = [], bArr: string[] = []): string[] => {
  return [...new Set([...aArr, ...bArr])]
}

export const addNouns = (ls = []): number => {
  nouns = mergeArray(nouns, ls)
  return nouns.length
}

export const addAdjectives = (ls = []): number => {
  adjectives = mergeArray(adjectives, ls)
  return adjectives.length
}

export const addTemplates = (ls = []): number => {
  sentenceTemplates = mergeArray(sentenceTemplates, ls)
  return sentenceTemplates.length
}

export const setNouns = (ls = []): number => {
  nouns = [...new Set([...ls])]
  return nouns.length
}

export const setAdjectives = (ls = []): number => {
  adjectives = [...new Set([...ls])]
  return adjectives.length
}

export const setTemplates = (ls = []): number => {
  sentenceTemplates = [...new Set([...ls])]
  return sentenceTemplates.length
}

export const getNouns = (): string[] => {
  return [...nouns]
}

export const getAdjectives = (): string[] => {
  return [...adjectives]
}

export const getTemplates = (): string[] => {
  return [...sentenceTemplates]
}